import { Box, Center, Spinner, Table, Tbody, Td, Text, Th, Thead, Tooltip, Tr, Badge, Flex } from '@chakra-ui/react'
import { getStatusColor, statusConfig } from '../utils/statusConfig'

export function PedidosTable({ pedidos = [], isLoading, isFetching, isRefetching, error }) {
  if (isLoading && !isFetching) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Spinner size="xl" color="#378BBF" thickness="4px" />
        </Center>
      </Box>
    )
  }

  if (error) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Text color="red.500" fontSize="12px">
            Erro ao carregar pedidos. Tente novamente mais tarde.
          </Text>
        </Center>
      </Box>
    )
  }

  if (pedidos.length === 0 && !isLoading && !isFetching) {
    return (
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto">
        <Center p={10}>
          <Text color="#313E44" fontSize="12px">
            Nenhum pedido encontrado.
          </Text>
        </Center>
      </Box>
    )
  }

  return (
    <Box borderWidth="1px" borderColor="gray.200" borderRadius="8px" overflowX="auto" position="relative">
      {/* Indicador de carregamento no canto superior direito */}
      {(isFetching || isRefetching) && (
        <Flex position="absolute" top="10px" right="10px" zIndex={2} bg="blue.50" p={2} borderRadius="md" alignItems="center" shadow="md">
          <Spinner size="sm" color="#378BBF" mr={2} />
          <Text fontSize="xs" color="#378BBF" fontWeight="medium">
            {isRefetching ? 'Atualizando...' : 'Carregando...'}
          </Text>
        </Flex>
      )}

      <Table
        variant="striped"
        size="sm"
        colorScheme="blackAlpha"
        sx={{
          'tr:nth-of-type(odd) td': { bg: 'white !important' },
          'tr:nth-of-type(even) td': { bg: '#F4F5F5 !important' },
          'th, td': { textAlign: 'center !important' },
        }}
      >
        <Thead bg="#378BBF">
          <Tr>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Data
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Pedido
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Data Aprovação
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Cód. Do Produto
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Produto
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Cor
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Gravação
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Recebimento
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Status Atual
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Próxima Etapa
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Estimativa De Prazo De Produção
            </Th>
            <Th fontSize="12px" fontWeight="normal" px={3} py={3} color="white" textAlign="center">
              Limite Produção
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {pedidos.map((pedido, index) => (
            <Tr key={index}>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.data}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.link_pdf ? (
                  <Text
                    as="a"
                    href={pedido.link_pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    textDecoration="underline"
                    color="#378BBF"
                    _hover={{ color: '#2c6d96' }}
                  >
                    {pedido.numero_pedido}
                  </Text>
                ) : (
                  <>{pedido.numero_pedido}</>
                )}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.dataAprovacao}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.codigoProduto}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.produto}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.cor}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.gravacao}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.recebimento}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                <Tooltip
                  label={
                    <Box>
                      <Text fontWeight="bold">{pedido.statusAtual}</Text>
                      <Text fontSize="xs">{statusConfig[pedido.statusAtual]?.description || ''}</Text>
                    </Box>
                  }
                  hasArrow
                  placement="top"
                  openDelay={300}
                >
                  <Badge
                    colorScheme={getStatusColor(pedido.statusAtual)}
                    p={2}
                    borderRadius="md"
                    fontWeight="medium"
                    fontSize="11px"
                    width="100%"
                    display="block"
                    textAlign="center"
                  >
                    {pedido.statusAtual}
                  </Badge>
                </Tooltip>
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                <Tooltip
                  label={
                    <Box>
                      <Text fontWeight="bold">{pedido.proximaEtapa}</Text>
                      <Text fontSize="xs">{statusConfig[pedido.proximaEtapa]?.description || ''}</Text>
                    </Box>
                  }
                  hasArrow
                  placement="top"
                  openDelay={300}
                >
                  <Badge
                    colorScheme={getStatusColor(pedido.proximaEtapa)}
                    p={2}
                    borderRadius="md"
                    fontWeight="medium"
                    fontSize="11px"
                    width="100%"
                    display="block"
                    textAlign="center"
                  >
                    {pedido.proximaEtapa}
                  </Badge>
                </Tooltip>
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.estimativaPrazo}
              </Td>
              <Td fontSize="12px" px={3} py={3} color="#313E44" textAlign="center">
                {pedido.limitePrazo}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  )
}
